import { memberSignInAttribute } from "./logIn.description";

export const formAttribute = [memberSignInAttribute[0]];

export const signinDescription = "Sign up to learn more about yourself.";
